import * as FileManager from '../../SDK/FileManager'

const history = {
  state: {
    isAuth: false,
    history: [],
    comments_total: 0,
    historyStatus: -1,
    page_num: 0
  },
  getters: {
    getHistory: state => state.history
  },
  mutations: {
    setHistory (state, obj) {
      state.history = obj
    },
    setStatus (state, obj) {
      state.historyStatus = obj
    }
  },
  actions: {
    getHistory ({commit}, obj) {
      let currentFile = obj.param.currentFile
      FileManager.getHistory(currentFile)
        .then(response => {
          if (response.length !== 0) {
            commit('setStatus', {code: 200, message: 'OK'})
            commit('setHistory', response)
          } else {
            commit('setStatus', {code: 0, message: 'OK'})
            commit('setHistory', [])
          }
        }, err => {
          commit('setStatus', {code: 201, message: 'OK'})
          commit('setHistory', [])
          console.log(err)
        })
    },
    deleteHistory ({commit}, obj) {
      FileManager.deleteHistory(obj)
        .then(response => {
          console.log(response)
        })
    },
    restore ({commit}, obj) {
      FileManager.restore(obj.param).then(response => {
        commit('setStatus', {code: 201, message: 'OK'})
      }, err => {
        console.log(err)
        commit('setStatus', {code: 202, message: err.message})
      })
    }
  }
}
export default history



// WEBPACK FOOTER //
// ./src/store/modules/history.js